import React from 'react';
import { Row } from 'antd';
import { SortableContainer } from 'react-sortable-hoc';

const SortableCardContainer = SortableContainer(({ children }): JSX.Element => <Row gutter={[8, 3]}>{children}</Row>);

export default SortableCardContainer;
